var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":_vm.newTitle,"visible":_vm.dialogVisible,"width":"700px","before-close":_vm.handleClose},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"dialogList"},[_c('p',{staticClass:"normalList_p"},[_vm._v(_vm._s(_vm.detail.suggest_content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }